<template>
    <div>
        <el-form-item label="相关附件">
            <el-upload
                class="upload-demo"
                action="/jgfast/sys/comm/upload"
                :show-file-list="false"
                :headers="headerObj"
                multiple
                :before-upload = "beforeUpload"
                accept="video/*, image/*"
                :on-success="handleFileSuccess"

            >
                <template #trigger>
                    <div class="workordr_upload">
                        <el-icon>
                            <upload/>
                        </el-icon>
                        添加附件
                    </div>
                </template>
            </el-upload>
        </el-form-item>
        <!--<div class="workordr_file" style="padding-left:120px;">-->
            <!--<div class="workordr_file_list" v-for="(item,index) in fileList" :key="item.id">-->
                <!--<ul>-->
                    <!--<li>-->
                        <!--<img v-if="item.fileImg=='1'" class="workordr_file_icon" src="../../assets/images/ico_pdf.png"-->
                             <!--alt="">-->
                        <!--<img v-else-if="item.fileImg=='2'" class="workordr_file_icon"-->
                             <!--src="../../assets/images/ico_word.png" alt="">-->
                        <!--<img v-else-if="item.fileImg=='3'" class="workordr_file_icon"-->
                             <!--src="../../assets/images/ico_excel.png" alt="">-->
                        <!--<img v-else-if="item.fileImg=='4'" class="workordr_file_icon"-->
                             <!--src="../../assets/images/ico_tp.png" alt="">-->
                        <!--<img v-else-if="item.fileImg=='5'" class="workordr_file_icon"-->
                             <!--src="../../assets/images/ico_yp.png" alt="">-->
                        <!--<img v-else-if="item.fileImg=='6'" class="workordr_file_icon"-->
                             <!--src="../../assets/images/ico_other.png" alt="">-->
                        <!--<img v-else class="workordr_file_icon" src="../../assets/images/ico_other.png" alt="">-->
                        <!--{{item.fileName}}-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--{{item.fileSizeShow}}-->
                    <!--</li>-->
                    <!--<li>-->
                        <!--<div>-->
                            <!--<el-icon class="circle-check-icon">-->
                                <!--<circle-check/>-->
                            <!--</el-icon>-->
                        <!--</div>-->
                        <!--<div class="">-->
                            <!--<el-icon class="view-icon" @click="handleFilePreview(item)">-->
                                <!--<View/>-->
                            <!--</el-icon>-->
                            <!--<span class="icon-download_2_line" @click="handleFileDownload(item)"></span>-->
                            <!--<el-icon class="view-delete" @click="handleFileRemove(index)">-->
                                <!--<delete/>-->
                            <!--</el-icon>-->
                        <!--</div>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
        <!--</div>-->
        <div class="Jsjb_file" :style="{'padding-left':paddingLeft+'px'}">
            <div class="file_list">
                <div class="file_list_img" >
                    <div class="file_list_img_item"  v-for="(item,index) in imgFileList">
                        <img :src="item.src" alt="">
                        <div class="file_list_img_modal">
                            <i class="icon-eye_line" @click="handleImgPreview(imgFileList,item,index)"></i>
                            <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                            <el-icon class="icon-remove" @click="handleFileRemove(item,'img',index)">
                                <delete/>
                            </el-icon>
                        </div>
                    </div>
                </div>
                <div class="file_list_img" >
                    <div class="file_list_img_item" v-for="(item,index) in radioFileList">
                        <img src="../../assets/images/radioImg.png" alt="">
                        <div class="file_list_img_modal">
                            <i class="icon-eye_line" @click="handleFilePreview(item)"></i>
                            <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                            <el-icon class="icon-remove" @click="handleFileRemove(item,'radio',index)">
                                <delete/>
                            </el-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ImgCarousel ref="imgCarouselChild" :imgList="imgFileList" :imgListIndex="imgListIndex"></ImgCarousel>
</template>

<script>
    import {reactive, ref, onMounted, getCurrentInstance, watch} from 'vue';
    import {filePreview, fileDownload} from '../../assets/js/base.js';
    import ImgCarousel from '@/components/ImgCarousel/ImgCarousel.vue';
    export default {
        name: "Wordorder_file",
        props: ["fileList","paddingLeft"],
        components: {ImgCarousel},
        setup(props, context) {
            const fileList = ref([]);
            let imgFileList = ref([])
            let radioFileList = ref([])
            const {proxy} = getCurrentInstance();
            //上传请求头部
            const headerObj = ref({
                "device": "H5",
                "token": localStorage.getItem('user_token')
            })
            const handleFileSuccess = (param) => {
                // fileList.value.push(param)
                param.fileId = param.id;
                param.src = "/jgfast/sys/comm/fileUploadView?fileId="+param.fileId
                if(param.fileImg ==4){
                    imgFileList.value.push(param)
                }else{
                    radioFileList.value.push(param)
                }
                context.emit("fileListToParent", param);
            }
            //文件查看
            const handleFilePreview = (param) => {
                // proxy.$axios.get("/jgfast/sys/comm/fileUploadView", {
                //     fileId:param.fileId
                // }).then((res) => {
                // });
                filePreview(param.fileName, param.id)
            }
            //文件下载
            const handleFileDownload = (param) => {
                // proxy.$axios.get("/jgfast/sys/comm/download", {
                //     fileId:param.fileId
                // }).then((res) => {
                // });
                fileDownload(param.id)
            }
            //文件删除
            const handleFileRemove = (param,type,indexFile) => {
                // var index = wordOrderIputForm.fileIds.indexOf(param.fileId);
                // wordOrderIputForm.fileIds.splice(index, 1);
                if(type=="img"){
                    imgFileList.value.splice(indexFile, 1);
                }else{
                    radioFileList.value.splice(indexFile, 1);
                }

                // fileList.value.splice(param, 1)
                context.emit("deleteFile", indexFile);
            }
            watch(() => props.fileList, (val) => {
                fileList.value = val;
                if(val && Array.isArray(val)){
                    val.map(item => {
                        if (item.fileImg == 4) {
                            item.src = "/jgfast/sys/comm/fileUploadView?fileId=" + item.fileId
                            imgFileList.value.push(item)
                        } else if (item.fileImg == 6) {
                            radioFileList.value.push(item)
                        }
                    })
                }
            })
            let imgListIndex = ref(0)
            let imgCarouselChild = ref()
            const handleImgPreview =(imgFileList,item,index)=>{
                imgListIndex.value = index;
                imgCarouselChild.value.showImgCarousel()
            }
            const beforeUpload = (file)=>{
                console.log(file)

            }
            let paddingLeft = ref(Number(props.paddingLeft)-16)
            return {
                handleFileSuccess,
                fileList,
                handleFilePreview,
                handleFileDownload,
                handleFileRemove,
                headerObj,
                imgFileList,
                radioFileList,
                handleImgPreview,
                imgListIndex,
                imgCarouselChild,
                beforeUpload,
                paddingLeft
            }
        }
    }
</script>

<style scoped>

</style>
